import { render, staticRenderFns } from "./ViewCollection.vue?vue&type=template&id=976bab16&scoped=true&"
import script from "./ViewCollection.vue?vue&type=script&lang=js&"
export * from "./ViewCollection.vue?vue&type=script&lang=js&"
import style0 from "./ViewCollection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ViewCollection.vue?vue&type=style&index=1&id=976bab16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "976bab16",
  null
  
)

export default component.exports